import { type TNull, type TOptional, type TSchema, type TUnion, Type } from '@sinclair/typebox';

/**
 * Champ facultatif d'un corps d'ÉDITION (PUT / PATCH partiel) : absent = inchangé, `null` = effacer la
 * valeur. `meta.keep_null` est indispensable : sans lui, le pipe de validation du backend retire le
 * `null` du corps (le confond avec une propriété absente) et le champ ne serait jamais vidé. Inutile
 * en création, où absent et `null` valent « vide ».
 */
export const clearableOnUpdate = <T extends TSchema>(schema: T): TOptional<TUnion<[T, TNull]>> =>
  Type.Optional(Type.Union([schema, Type.Null()], { meta: { keep_null: true } }));
